import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import car from "../../assets/images/trans.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const TransCiroxKuriertransport = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="service-section bg-light">
      <Container className="px-4 px-md-5 py-5">
        <Row className="mb-5 text-center" data-aos="fade-down">
          <Col>
            <h2 className="fw-bold text-orange">
              {t("TransCiroXKuriertransport.title")}
            </h2>
          </Col>
        </Row>

        <Row className="align-items-center gy-4">
          <Col md={6} data-aos="fade-right" className="text-center">
            <img
              src={car}
              alt="Spedition Transport"
              className="img-fluid rounded shadow img-map"
            />
          </Col>
          <Col md={6} data-aos="fade-left">
            <h5 className="text-orange fw-semibold">
              {t("TransCiroXKuriertransport.subtitle")}{" "}
            </h5>
            <p className="text-muted fw-semibold fs-6">
              {t("TransCiroXKuriertransport.subtitle_description")}
            </p>
            <p className="text-muted fw-semibold fs-6">
              {t("TransCiroXKuriertransport.description")}
            </p>

            <Button
              variant="warning"
              size="lg"
              className="bg-orange-500 text-white mt-3"
              onClick={() => navigate("/register/driver")}
            >
              {t("AuftragInfoCards.advantages_button")}
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TransCiroxKuriertransport;
